import React from 'react';
import { useFromStore } from '../../utils/createStore';

function styleForThread(threadId) {
  if (!threadId) return false;
  return "\n    [data-thread-id=\"".concat(threadId, "\"] {\n      background-color: #ffe697;\n      border-bottom: 3px solid rgba(255, 230, 151, 1);\n    }\n    .dark-mode [data-thread-id=\"").concat(threadId, "\"] {\n      background-color: rgba(255, 231, 153, 0.25);\n    }\n  ");
}

function CommentHighlighter(_ref) {
  var store = _ref.store;
  var hoveredThreadId = useFromStore(store, 'hoveredThreadId');
  var styleString = React.useMemo(function () {
    return styleForThread(hoveredThreadId);
  }, [hoveredThreadId]);
  return React.createElement("style", null, styleString);
}

export default React.memo(CommentHighlighter);